<template>
    <div class="row justify-content-center">
        <div class="col-lg-9">
            <div class="login mt-0 wow zoomIn" data-wow-duration="1.5s">
                <div class="form">
                    <form action="">
                        <span class="login__sub-title text-left mb-2">Category</span>
                        <div class="row mb-5 justify-content-center">

                            <CoverUploader
                                :component-name="`category`"
                                :file="coverFile"
                                @update-cover="updateCategoryCover"
                            />


                            <div class="col-md-8">
                                <div class="row mb-3">
                                    <div class="col-12">
                                        <label class="form-group">
                                            <span class="form-label">Title Category</span>
                                            <input
                                                type="text"
                                                class="form-control"
                                                v-model="form.name"
                                            >
                                        </label>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label class="form-check">
                                                <input
                                                    type="checkbox"
                                                    class="form-check-input-checkbox"
                                                    v-model="form.isActive"
                                                >
                                                <span class="form-check-label color_primary">Make it Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span class="login__sub-title text-left mb-2">subcategory</span>

                        <ul class="categories__subcategory">
                            <draggable v-model="form.subcategories" @end="onDragEnd()">
                                <SubCategoriesList
                                    v-for="(subcategory, index) in form.subcategories"
                                    :key="subcategory.id"
                                    :category="subcategory"
                                    :index="index"
                                    @delete="deleteCategory"
                                />
                            </draggable>

                        </ul>

                        <div class="form-group mb-5" v-if="form.subcategories.length <= 0">
                            <a
                                class="btn btn_primary-outline w-100"
                                @click="openModal"
                            >
                                + add subcategory
                            </a>
                        </div>
                        <div class="add-link mb-4 text-left" v-else>
                            <a
                                @click="openModal"
                                href="javascript:void(0)"
                            >
                                + Add Subcategory
                            </a>
                        </div>
                        <CategoryModal
                            :modal-id="getCustomModalId('main', activeCategory.index)"
                            :title-text="`Add subcategory to ${form.name}`"
                            :props-value="activeCategory"
                            @create="addNewSubcategory"
                        />

                        <BaseButtons
                            :on-save="saveCategoryDetails"
                            :on-cancel="backToPreviousPage"
                        />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import BaseButtons from "../Common/BaseButtons.vue";
import AdminService from "../../services/AdminService";
import SubCategoriesList from "./SubCategoriesList.vue";
import CategoryModal from "../Common/CategoryModal.vue";
import ModalHandler from "../../mixins/ModalHandler";
import CoverUploader from "../Common/CoverUploader.vue";
import draggable from "vuedraggable";

export default defineComponent({
    name: "CategoryEditor",
    components: {draggable, CoverUploader, CategoryModal, SubCategoriesList, BaseButtons},
    mixins: [ModalHandler],
    props: {
        categoryId: Number | String
    },
    data() {
        return {
            activeCategory: {},
            deletedCategories: [],
            coverFile: null,
            form: {
                name: null,
                isActive: false,
                image: null,
                subcategories: [],
            }
        }
    },
    methods: {
        onDragEnd() {
            this.form.subcategories.forEach((item, index) => {
                item.sortingOrder = index + 1;
            });
        },
        updateCategoryCover(result) {
            this.coverFile = result
            this.form.image = result.id
        },
        async saveCategoryDetails() {
            this.$showLoadingMessage()

            try {
                if (this.categoryId) {
                    await AdminService.updateCategoryInfo(this.categoryId, {category: this.form, deleted: this.deletedCategories})
                    this.$showSuccessMessage('Category was updated')
                    window.location.href = `/admin/categories`
                } else {
                    await AdminService.createNewCategory(this.form)
                    this.$showSuccessMessage('Category was created')
                    window.location.href = `/admin/categories`
                }
            } catch {
                this.$showErrorMessage('The category was not saved, please try again')
            }
        },
        deleteCategory(result) {
           if (result.id) {
               this.deletedCategories.push(result.id)
               this.form.subcategories.splice(result.index, 1)
           } else {
               this.form.subcategories.splice(result.index, 1)
           }
        },
        async getCategoryInfo() {
            try {
                const {data: response} = await AdminService.getCategoryDetails(this.categoryId);
                this.form = response
                if(response.image) {
                    this.coverFile = response.image
                    this.form.image = response.image.id
                }
            } catch {
                console.error()
            }
        },
        openModal() {
            this.activeCategory = { index: 'new', name: '' };
            this.titleText = `Add new subcategory`;
            this.showCustomModal('main', 'new');
        },
        addNewSubcategory(result) {
            this.form.subcategories.push({...result,  subcategories: []})
        }
    },
    mounted() {
        if( this.categoryId) {
            this.getCategoryInfo()
        }
    }
})
</script>


<style scoped>

</style>
